import { useOrderCreateStore } from '@/stores/order-create'
import { UserStep } from './components/UserStep'
import { ProductStep } from './components/ProductStep'
import { AddressStep } from './components/AddressStep'
import { ConfirmStep } from './components/ConfirmStep'
import { OrderResult } from './components/OrderResult'
import { cn } from '@/lib/utils'
import { Check } from 'lucide-react'

const steps = ['选择用户', '选择商品', '收货地址', '确认下单']

export function CreateOrderPage() {
  const { currentStep, setStep, createdOrderId } = useOrderCreateStore()
  const isComplete = createdOrderId !== ''

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-2xl font-bold">手动创建订单</h1>

      {!isComplete && (
        <div className="flex items-center justify-center gap-2 mb-8">
          {steps.map((label, index) => (
            <div key={label} className="flex items-center">
              <button
                onClick={() => index < currentStep && setStep(index)}
                className={cn(
                  'flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors',
                  index < currentStep && 'bg-primary text-primary-foreground cursor-pointer',
                  index === currentStep && 'bg-primary text-primary-foreground',
                  index > currentStep && 'bg-muted text-muted-foreground'
                )}
                disabled={index > currentStep}
              >
                {index < currentStep ? (
                  <Check className="h-4 w-4" />
                ) : (
                  <span className="h-5 w-5 rounded-full border-2 border-current flex items-center justify-center text-xs">
                    {index + 1}
                  </span>
                )}
                {label}
              </button>
              {index < steps.length - 1 && (
                <div className="w-12 h-0.5 bg-border mx-1" />
              )}
            </div>
          ))}
        </div>
      )}

      {isComplete ? (
        <OrderResult />
      ) : (
        <>
          {currentStep === 0 && <UserStep />}
          {currentStep === 1 && <ProductStep />}
          {currentStep === 2 && <AddressStep />}
          {currentStep === 3 && <ConfirmStep />}
        </>
      )}
    </div>
  )
}
